import { combineReducers } from "redux";

import posts from './posts'; // importing posts reducer

export const reducers= combineReducers({ posts})